window.Views = {
    Example: require('./views/example'),
    Exa51Test: require('./views/exa51test'),
    BatchProduction: require('./views/batch-production'),
    ReceiveList: require('./views/receive-list')
};

window.ProductionPlanner = require('./production-planner');
window.InlineFormHelper = require('./inline-form-helper');
window.MaterialRequiredAnalysisHelper = require('./material-required-analysis-helper');
window.BatchAnalaysisMeasurementsHelper = require('./batch-analysis-measurements-helper');


// Replace readonly select elements with hidden input elements and disable select elements
var readonlySelects = document.querySelectorAll('select[readonly]');
for(var i = 0; i < readonlySelects.length; i++)
{
    var select = readonlySelects[i];
    select.disabled = true;

    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = select.name;
    hidden.value = select.value;

    select.parentElement.insertBefore(hidden, select);
}

window.selectNextAvailable = function(selectElement, selectElements, ignoreIndexes)
{
    ignoreIndexes = ignoreIndexes === undefined ? [] : ignoreIndexes;

    if (selectElements.length == 1 && selectElement.options.length > 0)
    {
        selectElement.selectedIndex = 1;
        return;
    }

    var option, found, existingSelectElement;
    for(var i = 0; i < selectElement.options.length; i++)
    {
        option = selectElement.options[i];                

        found = false;

        for(var j = 0; j < selectElements.length; j++)
        {
            existingSelectElement = selectElements[j];

            if (existingSelectElement == selectElement)
            {
                continue;
            }
            
            if (existingSelectElement.options[existingSelectElement.selectedIndex].value == option.value)
            {
                found = true;

                break;
            }
        }

        if (!found && ignoreIndexes.indexOf(i) == -1)
        {
            selectElement.selectedIndex = i;
            if (selectElement.getAttribute('data-select-next-available') == 'readonly') {
                selectElement.setAttribute('readonly', '');
            }
            var valueElement = selectElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[data-select-next-available]');
            console.log({valueElement: valueElement})
            if (valueElement && valueElement.getAttribute('data-select-next-available') == 'set-attributes') {
                valueElement.setAttribute('data-is-measurement-field', '');
                valueElement.setAttribute('data-type', selectElement.options[selectElement.selectedIndex].value);
            }
            console.log(i);
            break;
        }
        else
        {
            
        }
    }
}

var confirmMissingAnalyzes = document.querySelector('.confirm-missing-analyzes');

if (confirmMissingAnalyzes)
{
    confirmMissingAnalyzes.addEventListener('click', function(e)
    {
        e.preventDefault();
        e.stopPropagation();

        swal({
            title: pgettext('Confirm message', 'Some batches of this shipment are still missing their analyzes. Do you want to send it anyway?'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            cancelButtonText: gettext('Cancel'),
            confirmButtonText: gettext('Yes'),
            closeOnConfirm: true
        }, function () {
            confirmMissingAnalyzes.form.submit();
        });
    });
}

var autoFocusInvalidAnalyze = document.querySelector('#batch_form.autofocus-invalid-field');

if (autoFocusInvalidAnalyze)
{
    var field = autoFocusInvalidAnalyze.querySelector('input.form-control-danger');

    if (field)
    {
        field.scrollIntoView();
    }
}

var selectAllWagons = document.getElementById('selectAllWagons');
if (selectAllWagons)
{
    selectAllWagons.addEventListener('change', function(e)
    {
        var checkboxes = document.querySelectorAll('.select-wagon');
        for(var i = 0; i < checkboxes.length; i++)
        {
            checkboxes[i].checked = selectAllWagons.checked;
        }
    });
}